(function () {
  'use strict';

  angular.module('wsLrs.controllers').controller('ActivityAliasesCtrl', ['$scope', '$controller', '$http', '$timeout', '$uibModal', 'Api', function ($scope, $controller, $http, $timeout, $uibModal, Api) {
    $scope.defaultSortBy = "name";
    $scope.sortControls = [{
      "title": "Activity",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      }
    }, {
      "title": "Aliases",
      "options": {
        "Ascending": "aliasCount",
        "Descending": "-aliasCount"
      }
    }];
    $scope.downloadUrl = Api.url("/acc/activities/aliases/csv");
    $scope.apiUrl = Api.url("/acc/activities/aliases");
    $scope.uiConfig = {
      hideDownloadUrl: true
    };
    function fetchAliases() {
      return $http.get($scope.apiUrl, {
        "_limit": 1,
        "_offset": 0
      });
    }
    function ifAliasesExist(f, g) {
      return fetchAliases().then(function (_ref) {
        var count = _ref.data.count;
        return count > 0 ? f() : g();
      });
    }
    var onlyWhenAliasesExist = function onlyWhenAliasesExist(f) {
      return ifAliasesExist(f, function () {
        return undefined;
      });
    };
    var hideDownloadUrl = $scope.$safeApply.bind($scope, function () {
      $scope.uiConfig.hideDownloadUrl = true;
    });
    var showDownloadUrl = $scope.$safeApply.bind($scope, function () {
      $scope.uiConfig.hideDownloadUrl = false;
    });
    var handleActivityEdit = _.debounce($scope.$safeApply.bind($scope, function () {
      ifAliasesExist(showDownloadUrl, hideDownloadUrl);
    }), 500);
    onlyWhenAliasesExist(showDownloadUrl);
    $scope.$on('verb-edited', handleActivityEdit);
    $scope.formatSearchSuggestion = function formatSearchSuggestion(result) {
      return result.name;
    };
    $scope.processFetchResponse = function (response) {
      return response.data;
    };
    $scope.defaultSearchBy = "searchTerm";
    $scope.searchPlaceholder = "Search for an alias";
    $scope.editAlias = function editAlias(_aliasTarget) {
      var modal = $uibModal.open({
        controller: "ActivityAliasEditModalCtrl",
        templateUrl: 'modules/app/data/activities/aliases/alias-edit-modal.html',
        backdrop: 'static',
        size: 'lg',
        resolve: {
          aliasTarget: function aliasTarget() {
            return _aliasTarget;
          }
        }
      });
      modal.closed.then(function () {
        $scope.fetch();
      });
    };
    $scope.addAliases = function addAliases() {
      $scope.editAlias(null);
    };
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });
  }]).controller('ActivityAliasEditModalCtrl', ['$scope', '$controller', '$http', '$timeout', '$uibModalInstance', 'Alerts', 'Api', 'Logger', 'Utils', 'aliasTarget', '$rootScope', function ($scope, $controller, $http, $timeout, $uibModalInstance, Alerts, Api, Logger, Utils, aliasTarget, $rootScope) {
    var aliasEndpoint = Api.url("/acc/activities/aliases");
    $scope.close = function () {
      $uibModalInstance.dismiss();
    };
    $scope.aliasTarget = aliasTarget;
    if (aliasTarget) {
      $scope.apiUrl = Api.url("/acc/activities?aliasId=" + aliasTarget.activityId);
    } else {
      // Setup activity selector to choose aliasTarget
      $scope.selectedActivity = null;
      $scope.$watch("selectedAliasTarget", function (newValue) {
        if (newValue) {
          $scope.aliasTarget = newValue;
          $scope.apiUrl = Api.url("/acc/activities?aliasId=" + newValue.activityId);
          $scope.clearSelectedAliasSource();
          $scope.resetPage();
        }
      });
    }
    $scope.addAlias = function addAlias() {
      $scope.adding = true;
    };
    $scope.$watch("selectedAliasSource", function (aliasSource) {
      if (!aliasSource) {
        return;
      }
      $scope.clearSelectedAliasSource();
      $scope.successMessage = null;
      $scope.errorMessage = null;
      var aliasRule = {
        from: aliasSource.activityId,
        to: $scope.aliasTarget.activityId
      };
      $http.post(aliasEndpoint, aliasRule).then(function success() {
        $scope.$broadcast('item-added', aliasSource);
        $scope.adding = false;
        $scope.successMessage = "A new alias for '" + $scope.aliasTarget.name + "' has been created. " + "Please allow up to 30 minutes before this change is reflected in Watershed.";
      }, function error(response) {
        if (response && response.data) {
          $scope.errorMessage = response.data.message;
        }
      });
    });
    $scope.finishEditing = function finishEditing() {
      $rootScope.$broadcast('verb-edited');
      try {
        $scope.$dismiss('cancel');
      } catch (e) {
        Logger.warn(e);
      }
    };
    $scope.removeAlias = function removeAlias(fromAlias, index) {
      $scope.successMessage = null;
      $scope.errorMessage = null;
      var aliasRule = {
        from: fromAlias.activityId,
        to: null
      };
      $http.post(aliasEndpoint, aliasRule).then(function success() {
        $scope.$broadcast('item-delete', index);
        $scope.successMessage = "The chosen alias for '" + $scope.aliasTarget.name + "' has been removed. " + "Please allow up to 30 minutes before this change is reflected in Watershed.";
      }, function error(response) {
        if (response && response.data) {
          $scope.errorMessage = response.data.message;
        }
      });
    };
    $scope.formatSearchSuggestion = function formatSearchSuggestion(result) {
      return result.name;
    };
    $scope.processFetchResponse = function (response) {
      return response.data;
    };
    $scope.defaultSearchBy = "name";
    $scope.searchPlaceholder = "Search for an alias";
    $scope.defaultSortBy = "name";
    $scope.sortControls = [{
      "title": "Activity",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      }
    }];
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });
  }]);
})();
